import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthService from '../services/AuthService';
import AuthLayout from '../components/ui/AuthLayout';
import { ADMIN_HOME_URL, FACILITY_LOGIN_URL } from '../services/apiConfig';

const Login = () => {
    const [isLoader, setIsLoader] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (AuthService.getCurrentUser()) {
            navigate('/dashboard');
        }
    }, [navigate]);

    const handleLogin = async (email, password) => {
        setIsLoader(true);
        try {
            const data = await AuthService.login(email, password);
            if (data?.status) {
                toast.success(data.message);
                const user = { ...data.data.admin, auth_token: data.data.auth_token };
                localStorage.setItem('admin', JSON.stringify(user));
                localStorage.setItem('permissions', JSON.stringify(data.data.permissions));
                window.location.href = ADMIN_HOME_URL;
            } else if (data) {
                toast.error(data.message);
            }
        } finally {
            setIsLoader(false);
        }
    };

    return (
        <AuthLayout
            eyebrow="Admin"
            title="Sign in to Helpio"
            subtitle="Manage bookings, partners and customers."
            heading="Everything your platform needs, in one place."
            intro="Track every booking from request to completion, onboard providers and facilities, and keep customers happy."
            points={[
                { icon: 'bi-calendar2-check', text: 'Live booking pipeline' },
                { icon: 'bi-buildings', text: 'Service providers & facility management' },
                { icon: 'bi-graph-up-arrow', text: 'Revenue and growth insights' },
            ]}
            onSubmit={handleLogin}
            isLoading={isLoader}
            switchLink={{ prompt: 'Are you a partner?', label: 'Go to the partner portal', href: FACILITY_LOGIN_URL }}
        />
    );
};

export default Login;
